module.exports = __webpack_public_path__ + "img/mingbai5_0d90e913c.png";